const langEN =
{
  bw: {
    bwh: {
      agent: {
        title: 'Display settings for each agent',
        NetPrice: 'Net price (excl. bookingfee)',
        NetPriceFee: 'Net price incl. bookingfee',
        NetPriceService: 'Net price + fixed services',
        GrossPrice: 'Gross price',
        NoResizer: 'No Resize',
        avPreview: 'Availability and price preview',
        PriceNoComm: 'Price on first Page',
        showavgprice: 'Show average price instead of total price',
        showtotservice: 'Show total price for services',
        resize: 'iframe resizer',
        css: 'Custom CSS',
        cssupload: 'Upload CSS file',
        cssremove: 'remove',
        redirect: 'Redirect to URL',
        avPreviewK: 'Preview',
        showavgpriceK: 'Day price',
        resizeK: 'Resizer',
        cssK: 'CSS',
        redirectK: 'Redirect',
        intLink: 'Website integration with Link',
        intWidget: 'Website integration with Widget',
        intIFrame: 'Website integration with iFrame',
        embedtitle: 'Embed BookWorldOnline into your website',
        language: 'Language',
        book: 'Booked by agent',
        noheadimg: 'No header image(s)',
        embed: 'Embed this code into your website',
        link: 'Place a link to this URL on your website',
      },
      discount: {
        title: 'Discount Codes',
        titleCreate: 'Create Discount Codes',
        titleEdit: 'Edit Discount Codes',
        prozent: 'percent',
        einmalig: 'onetime',
        nacht: 'per night',
        person: 'per person',
        person_nacht: 'per person and night',
        neu: 'New',
        benutzt: 'Used',
        inaktiv: 'Inactive',
        ankunft: 'Arrival',
        dauer: 'Nights',
        personen: 'Guests',
        ab: 'from',
        bisdatum: 'until',
        bis: 'to',
        force_agent: 'Switch agent to',
        dontchangeangent: 'no switch',
        error: {
          code: 'Only small letter, numbers and underline allowed.',
          codematch: 'For code <%{code}> discount has to be <%{rabatt}> and type has to be <%{typ}>.',
        },
      },
      guestfield: {
        title: 'Guest fields',
        titleEdit: 'Edit guest field',
        disp_opts: 'Display options',
        checkin: 'Check In',
        checkinlabel: 'Online Check-in',
        noShow: '-',
        orig_text: 'Original text',
        show: 'Show',
        req: 'Required',
        reqWoCc: 'Required, if no cc is necessary',
        noCheckin: '-',
        mainOpt: 'Main guest',
        allOpt: 'All guests',
        mainReq: 'Main (req)',
        allReq: 'All (req)',
        options: 'Select options',
        optionsdesc: 'One Option per line (store key as prefix with =)',
        validatedesc: 'email or regex',
      },
      hostel: {
        bedingung1: 'Condition 1',
        bedingung2: 'Condition 2',
        bedingung3: 'Condition 3',
        zahlunggelesen: 'Payment-Form-Checkbox',
        zahlunggeleseninfo: 'Payment-Form-Checkbox-Info',
        confirmtext: 'Booking-confirm',
        showbookingtext: 'Booking-display',
        confirminfotext: 'Confirmation information',
        cancelreservationtext: 'Cancellation confirmation',
        privacy: 'Privacy statement',
        contact: 'Impressum-Legal notice',
        resultfound: 'Offer found',
        noresultfound: 'No offer found',
        arrivaltimeoptions: 'Arrival time options',
        booknow: 'Button book',
        booknowweiter: 'Button book continue',
        booknowfinish: 'Button finalize booking',

        bild: 'Header image',
        buchbild: 'Booking sheet image',
        map: 'Hostel Map',
        zusatzbild: 'Additional Image',
        favicon: 'Favicon',
      },
      image: {
        title: 'Hostel images',
        titleEdit: 'Edit image',
        titleCreate: 'Create image',
        art: 'Image type',
        pos: 'Position',

        error: {
          invalidPos: 'This position already exists. Please use another position.',
        },
      },
      rate: {
        titelField:'Title',
      },
      roomcategory: {
        title: 'Room categories',
        titleEdit: 'Edit room',
        all: 'All',
        bezeichnung: 'Category',
        titel: 'Title',
        kurzbeschr: 'Short Description',
        beschr: 'Description',
        onbwh: 'Online',
        associated_rooms: 'Associated rooms',
        units: 'Units (e.g. "bed/beds/person/persons")',
      },
      service: {
        title: 'Service',
        titleEdit: 'Edit service',
        bezeichnung: 'Service',
        titel: 'Title',
        kurzbeschr: 'Short Description',
        onbwh: 'Online',
        free_cancel_list: 'Free Cancel',
        free_cancel: 'Free Cancelation',
        anz_modifier: 'Condition',
        deactivate: 'Set title to "NotActive" to deactivated service for that language.',
      },
      settings: {
        titleEdit:'Edit BookWorldOnline settings',
        grund: 'Base',
        konfig: 'Configuration',
        konfig2: 'Configuration 2',
        raten: 'Rates',
        inaktiv:'inactive',
        test:'Test',
        aktiv:'Active',
        haupt:'Main system',

        MixedOnly: 'Mixed rooms only',
        MixedOnlyAndFemale: 'Mixed and Female',
        FemaleOnly: 'Female only',
        AllPossibilities: 'All possibilities',
        NoGenderFilter: 'No gender filter',
        NoDorm: 'No dorms',
        NoFilter: 'No accomodation filter',

        No: 'No',
        Optional: 'Optional',
        Mandatory: 'Mandatory',
        identDesc: 'With the BookWorldOnline system you automatically get the Internet Address (URL) <a href="https://%{bwh_ident}.%{bwh_domain}" target="_blank">%{bwh_ident}.%{bwh_domain}</a>.',
        bwh_def_personen: 'Default number of persons',
        bwh_anz_personen: 'Maximum number of persons',
        bwh_childalterskat: 'Age category for child prices',
        bwh_childalterskat_helpertext: 'Which age categorie to be used for children',
        bwh_childinprivat: 'Children in private rooms allowed',
        bwh_childinprivat_helpertext: 'Children in private rooms allowed',
        bwh_childindorm: 'Children in dorm rooms allowed',
        bwh_childindorm_helpertext: 'Children in dorm rooms allowed',
        bwh_anz_naechte: 'Maximum number of nights',
        bwh_genderchoice: 'Gender / accomodation filter',
        lastNewRes: 'Last new reservation',
        lastNewRes_helpertext: 'until x h before 24:00 of arrival day',
        lastChange: 'Last change/Cancellation',
        lastChange_helpertext: 'until x h before 24:00 of arrival day',
        bwh_gastfeldstorelan: 'Store booking language in guest field',
        bwh_gastfeldstorelan_helpertext: 'Select a guest field to store the booking language',
        bwh_gelesenhacken: 'Display checkbox to tick before booking',
        bwh_gelesenhacken_helpertext: 'You can configure checkboxes e.g. to show privacy terms.',
        bwh_hideprivatmarker: 'Hide private room marker',
        bwh_hideprivatmarker_helpertext: 'Hides the marker of private rooms in result list',
        bwh_usearrivaltime: 'Arrival time',
        bwh_checkintime: 'Earliest check-in time',
        bwh_checkouttime: 'Latest check-out time',
        bwh_usearrivaltime_helpertext: 'Should guest set an arrival time?',
        bwh_child_min_age: 'Minimal child age',
        bwh_child_max_age: 'Maximal child age',
        bwh_maplink: 'Special Google map Link',
        bwh_mapapikey: 'Special Google map API key',
        bwh_analyticskey: 'Google Analytics key',

        error: {
          DefaultLang: 'Default language must be a part of the list of languages.',
          NoLang: 'There must be at least one language in the list of languages.',
          UseOnlyLetters: 'Not a valid host name. Use only lowercase letters, digits and hyphen (-).',
          TheAddressAlreadyExists: 'The address already exists.',
        },

        google: 'Google options',

        BookingFee: 'Booking fee',
        noFee: 'No booking fee',
        worldPay: 'WorldPay',
        stripe: 'Stripe',
        storePaymentInfo: 'Store payment information',
        noneExternal: 'No storage/external',
        local: 'local storage',
        cvv: 'CVV Number',
        noEntry: 'No entry',
        optional: 'Optional',
        required: 'Required',
        prefAddGast: 'Never update guests',
        update: 'update existing guest if match',
        alwaysNew: 'always add a new guest',
        ccTypes: 'Credit Cards',
        visa: 'Visa',
        master: 'Master',
        amex: 'AmEx',
        diners: 'Diners',

        MultiRoom: 'Multi-Room',
        SplitGroupInto2:  'Allow splitting in 2 Rooms',
        Split2Ex : 'z.B. 4,3 / 3,3',
        SplitGroupInto3:  'Allow splitting in 3 Rooms',
        Split3Ex : 'z.B. 4,3,2 / 3,2,2 / 2,2,2',
        SplitGroupIntoMoreThan3: 'Allow splitting in more than 3 Rooms',
        SplitMoreEx : 'z.B. 3,2,2,2 / 4,3,2,2',
        anzsingle : 'Max. Number of single rooms',
        disInfo1: 'Multi-Room allows booking of more than one private room with a single booking.',
        disInfo2: 'This feature is currently disabled for you. To have it enabled please contact',

        roomchange: 'Room-change',
        roomchange2: 'Allow room change during stay',
      },
      text: {
        title: 'Hostel texts',
        titleEdit: 'Edit hostel text',
        titleCreate: 'Create hostel text',
        imgTitle: 'Illustration',
        art: 'Text type',
        pos: 'Position',
        agent: 'Text for Agent',

        formatBlockTitle: 'Format description',
        formatTitle: 'Formatting',
        formatBold: '*bold*',
        formatItalic: '_italic_',
        formatHeading: 'h1. Heading',
        formatSubheading: 'h2. Subheading',
        ulTitle: 'Unordered List',
        ulOne: '* Item 1',
        ulTwo: '* Item 2',
        ulThree: '* Item 3',
        olTitle: 'Ordered List',
        olOne: '# Item 1',
        olTwo: '# Item 2',
        olThree: '# Item 3',
        allEntries: 'Show all',

        error: {
          wrongType: 'You can only delete text of types: "Confirmation information" or "Payment-Form-Checkbox-Info"',
          invalidPos: 'This position already exists. Please use another position.',
        },
      },
      translation: {
        exp_hostel_txt: 'Export hostel texts',
        select_file: 'Choose File',
        imp_txt: 'Import texts from selected text file',
        check: 'Check Language',
        no_file: 'No file chosen',
      },
    },
    cal: {
      calendar: {
        months: 'Months',
        monthfrom: 'Date from',
        monthto: 'Date to',
        startdate: 'Start date',
        enddate: 'End date',
        weekdays: 'Weekdays',
        assign: 'Assign',
        preis: 'Prices',
        zimmer: 'Rooms',
        online: 'Online',
        zusatz: 'Add. Services',
        notassigned: 'not assigned',
        mod1: 'Yield manager',
        mod2: 'RoomPriceGenie',
        nochange: 'No change',
        resetdaily: 'Reset daily price',
        undo: 'Undo ',
        pleasechoose: 'Please choose'
      },
      mwst: {
        title: 'Split VAT: ',
        titleCreate: 'Add entry',
        titleEdit: 'Edit entry',
        info: 'List of items which are included in the general price of a night, but have another VAT rate. The general defined VAT rate is displayed above.',
        empty: 'Empty bed',
        all: 'All',

        preisgr: 'Price group',
        preiskat: 'Room category',
        alterskat: 'Age category',
        text_de: 'Text German',
        text_en: 'Text English',
        text_fr: 'Text French',
        betrag: 'Price',
        type: 'Price type',
        mwst: 'VAT',

        createInfo: 'For each of these field combinations an entry will be created, if not already existing.',

        fix: ' (Fix)',
        fixSep: ' (Fix), separated',
        brut: '% (gross)',
        brutSep: '% (gross), separated',
      },
      online: {
        title: 'Online groups',
        titleCreate: 'add entry',
        titleEdit: 'edit entry',
        showall: 'Show All',
        compare: 'Compare',
        onlinegroup: 'Online group',

        copytitle: 'Copy online group',
        copyinfo: 'The entries of the selected online group will be copied. Please provide a name:',

        error: {
          deleteFailed: 'Could not delete online group. It is still assigned to date between %{1} and %{2}.',
        },
      },
      onlinecompare: {
        details: 'Details (id)',
        details2: 'Details (description)',
        strasse: 'Portal',
        pkbez: 'Room category',
        showall: 'Show All',
        zimmerb: 'Room',
      },
      oportal: {
        title: 'Online portals',
        titleCreate: 'add entry',
        titleEdit: 'edit entry',
        firma: 'Portal',
        id_agent: 'Portal',
        id_preiskat: 'Room category',
        id_online_gr: 'Online group',
        farbe: 'Color',
        copyTitle: 'New name',
        kontingent: 'Contingent / Bed(s)',
        freihalten: 'Keep free / Bed(s)',
        min_nacht: 'Minimum duration',
        max_nacht: 'Maximum duration',
        noarrivalwd: 'No arrival',
        nodeparturewd: 'No departure',
        firstres: 'First new reservation',
        lastnewres: 'Last new reservation',
        lastchange: 'Last change',
        lastminstart: 'Start',
        lastminend: 'End',
        room: 'Room',
        online: 'Online',
        bed: 'Bed',
        sperr_belegung: 'Occupancy*',
        sperr_belegung_info: '* Occupancies (separated by \',\') in the edit field at the right are not available online for that room.',
        emptyPortal: 'All portals',
        emptyRoomcat: 'All Roomcategories',
        ankunftstag:'arrival day',
        tag:'day',
        tage:'days',
        woche:'week',
        wochen:'weeks',
        cleanup: 'Remove assignment',
        cleanupInfo: 'The following room assignment will be removed:  |||| The following %{smart_count} room assignments will be removed: ',
        mappingcopy: 'Copy mapping to online groups',
        multiedit: 'Multiedit',
        multicopy: 'Copy to online group',
        copyinfo: 'Change the field',
        copyinfo2: 'for all selected rows and set the value to',
        copyinfo3: 'All selected rows will be copied to:',
        mapcopyinfo: 'The mapping of the selected rows will be copied to the selected groups:',
        MBookingInfo: '<b>Main booking period</b><br>In days before 24:00 of arrival day (e.g. 0.75 => 06:00 AM of arrival day)<br>A value of -1 in both fields corresponds to the global settings.',
        SBookingInfo: '<b>Secondary booking period</b> (Last Minute)<br>In hours before 24:00 of arrival day (e.g. 18 => 06:00 AM of arrival day)<br>A value of -1 in both fields corresponds to the global settings.',
        meField: 'Field',
        meValue: 'New value',
        me: {
          kontingent: 'Contingent',
          freihalten: 'Keep free',
          min_nacht: '*Minimum duration',
          max_nacht: '*Maximum duration',
          noarrivalwd: '*no arrival',
          nodeparturewd: '*no departure',
          firstres: 'Main booking period -> first new reservation',
          lastnewres: 'Main booking period -> last new reservation',
        },
        error: {
          copyMessage:'Some rows are already in the target group. They were not copied.',
          duplicateEntry: 'Duplicate entry: This combination of agent and room category does already exist.',
          validateSperrBelegung: "Invalid occupancy: Only numbers, 'm', 'f', 'x' and ',' allowed",
          validateFirstLastres: "the fields 'First new reservation' and 'Last new reservation' either both or none should be set to -1.",
          validateLastminStartEnd: "the fields 'Start' and 'End' either both or none should be set to -1.",
          missConfig: "Missconfiguration detected - ",
          missConfig2: "The following room is assigned to the wrong roomtype:  |||| The following %{smart_count} rooms are assigned to the wrong roomtype: ",
        },
      },
      pricegr: {
        title: 'Price',
        titleCreate: 'Add entry',
        titleEdit: 'Prices',
        editMwst: 'VAT',
        editRate: 'Rates',
        filterTitle: 'List filter:',
        showall: 'Show All',
        compare: 'Compare',
        compareRate: 'Compare (Rate)',
        compareVAT: 'Compare (VAT)',
        createInfo: 'For each of these field combinations an entry will be created, if not already existing.',

        copytitle: 'Copy price definition',
        copyinfo: 'The entries of the selected definition will be copied. Please provide a name:',

        error: {
          deleteFailed: 'Could not delete price definition. It is still assigned to date between %{1} and %{2}.',
        },
      },
      pricegrcompare: {
        bezeichnung: 'Description',
        alterskat: 'Age category',
        belegung: 'Occupancy',
        filterTitle: 'List filter:',
        showall: 'Show All',
      },
      pricegrcomparerate: {
        rate: 'Rate',
      },
      rate: {
        title: 'Rates',
        preisgr: 'Price group',
        titleCreate: 'Add entry',
        titleEdit: 'Edit entry',
        info: 'Activate and adjust prices for rates of connected system (interfaces)',
        filterInfo: 'Show rooms/price based on online group: ',

        name: 'Description',
        rooms: 'Rooms',
        price: 'Base price',
        empty: '** Undefined **',
        copy: 'copy to all',
      },
      portal: {
        firma: 'Portal',
        kontingent: 'Cont.',
        freihalten: 'keep free',
        id_preiskat: 'Room category',
        zimmer: 'Room',
        min_nacht: 'Min',
        max_nacht: 'Max',
        noarrivalwd: 'n.Arr.',
        nodeparturewd: 'n.Dep.',
        firstres: 'First',
        lastnewres: 'New',
        lastchange: 'LM Change',
        lastminstart: 'LM Start',
        lastminend: 'LM End',
      },
      service: {
        title: 'Services',
        titleCreate: 'add services',
        titleEdit: 'edit service',
        showall: 'Show All',
        servicegroup: 'Service group',

        copytitle: 'Copy service group',
        copyinfo: 'The price entries of the selected group will be copied to the new group. Please provide a name for the new group:',

        error: {
          deleteFailed: 'Could not delete service definition. It is still assigned to date between %{1} and %{2}.',
        },
      },
      serviceprice: {
        title: 'Service prices',
        titleCreate: 'add service price',
        titleEdit: 'edit service price',
      },
      yield: {
        confirmTitel:'Unsaved changes',
        confirmText:'Discard all changes?',
        save:'Save',
        priceDisplay:'Price display',
        def:'Default',
        det:'Details',
        avg:'Average booked',
        limits:'Limits',
        days:'Days',
        date:'Date',
        empty:'Do not count empty beds',
        groups:'Groups',
        occ:'Occupancy',
      }
    },
    dashboard: {
      past: 'Past',
      future: 'Future',
      month:'1 Month |||| %{smart_count} Months',
      restricted_text:'<h2>Access restricted</h2>There is an access restriction.<br>All system work in the background as usual.<br>Please contact us immediately:<br><br>alixon (Andreas/Hansj&uuml;rg):<br>+41-62-511-22-34<br><a href="mailto:support@book.world">support@book.world</a><br><br>',
      resolved:' resolved since ',
      contact: {
        title:'Send your Request',
        error:'Error! Message could not be sent.',
        property:'Property',
        user:'User',
        email: 'Email',
        subject: 'Subject',
        text: 'Text',
        sent: 'Message has been sent',
        send: 'Send Request',
      },
      info_archive: {
        title: 'Information archive'
      },
      incident_archive: {
        title: 'Archive of incidents', 
        incident: 'Incident: ',
        resolved: 'Resolved since '
      },
      incident_edit: {
        title: 'Edit incidents', 
        startDate: 'Start Date', 
        endDate: 'End Date', 
        incident: 'Incident',
        maintenance: 'Maintenance',
        breakdown: 'Breakdown',
        other: 'Other',
        update: 'Update',
        resolved: 'Resolved since '
      }
    },
    if: {
      list: {
        titleAdditional: 'Additional available interfaces',
      },
      portal: {
        tab1: 'Availabilities',
        tab2: 'Actions',
        tab3: 'Settings',
        tab4: 'Import/Export',
        UpdateRoomtypesText: 'room types from portal',
        UpdateRoomtypesButton: 'Start import',
        chLoginname:'change Loginname',
        changePwd: 'change Password',
        ReservationHolen: 'import Reservation from portal',
        importLbl: 'Import',
        setup: 'Setup',
        importRes: 'The reservation is scheduled to be imported.',
        importRoomTypes: 'The room types are schedules to be imported. An e-mail will be sent upon finish.',
        importRoomTypesHTML: 'The room types are imported.',
        GlobalRoomAssignment: 'Room type assignment',
        chGlobalRoomAssignment: 'save assignment',
        ManualRoomInformation: 'Room details',
        chManualRoomInformation: 'Save room informations',
        roomsize: 'Room size',
        roomcnt: 'number of rooms',
        defaultsize: 'minimum occupancy',
        prtAvailShow: 'show portal availabilities (number of beds/rooms)',
        Einrichten: 'Configure',
        findHB_hostelnumber: 'search a booking and take the number before the "-" (eg Booking number 39424-2980406, so the Hostelnumber is 39424) '+
                              'or search the Hostel on hostelbookers.com take the Link to the detail information and '+
                              'look for the enclosed value "intpropertyid".',
        InterfaceUp: 'Interface running',
        InterfaceDown: 'Interface stopped',
        changeUp: 'start Interface',
        changeDown: 'stop Interface',
        updateAvailText: 'Availabilities/Prices',
        updateAvailButton: 'set all',
        updateAvailConfirm: 're-send of all availabilities and prices is scheduled.',
        resetCacheText: 'Portal cache',
        resetCacheButton: 'Reset',
        resetCacheConfirm: 'reset of portal cache done.',
        FirstErrorResetText: 'FirstError',
        FirstErrorResetButton: 'Reset (FirstError)',
        FirstErrorResetConfirm: 'Reset of FirstError flag is scheduled.',
        save_config_fields: 'save values',
        corruptTitel: 'Not configured.',
        corruptText : 'The interface is not configured correctly. Please contact support.',
        bed:'Bed',
        beds:'Beds',
        room:'room',
        rooms:'rooms',
        unit:'unit',
        units:'units',
        days: 'days',
        ratelegende:'Rates: Price (rounded)',
        technicalDetails:'Technical details',
        c_cribPrice:'crib price',
        c_meals:'meals',
        c_advance:'last new reservation (days)',
        c_guarantee:'guarantee',
        inboxPasswort:'Inbox user',
        inboxUser:'Inbox password',

        roomdetails:'Room details',
        saveroomdetails:'Save Room details',
        gender0:'Dormitory female',
        gender1:'Dormitory male',
        gender2:'Dormitory mixed',
        gender4:'Private room',
        gender:'Gender',

        timeSync:'Synchronisation period:',
        timeNow: 'Current Time at hostel (timezone):',
        timeLast: 'last new reservation for arrival today:',
        timeSet: 'set',
      }
    },
    glob: {
      findres: {
        title1: 'Nachforschung Reservation',
        title2: 'Nachforschung Hostel',
        title3: 'Login Check (admin & Dormbook)',
      },
      hostel:{
        basis: 'base',
        abrechnung: 'Accounting',
        res_email_help: 'This e-mail address is used for reservation confirmations (DormOnline and Interfaces)',
        koordinaten_help: 'Example: -5.214569',
        max_dormbook_help: '(for each additional licence EURO 10.- per month will be charged)',
        validate_cc_text: 'Only capital letters A-Z, digits 0-9 or spaces. Max 22 character.',
        validate_login_name: 'Invalid login name. Only small letters, numbers and \'_\' allowed. The login has to start with a letter',
        validate_max_dormbook: 'The number of licences must be a number.',
        copytitle: 'Copy Hostel',
        copyhostel_info: 'Temporarily enable exactly one additional hostel for copying. 322 is only an example for the required hostel ID. The permission comes from the server via can_copy; the GUI does not read the file itself.',
        archive: 'Archive hostel',
        archivetitle: 'Archive hostel',
        archiveinfo: 'Enter the current login name exactly to confirm.',
      },
    },
    rep: {
      bookingcom: {
        noFile: 'no file selected',
        WarnText: 'Attention: The csv the file is only accepted if it was generated in the extranet with English language settings!',
        UploadText: 'Upload Statement from booking.com in CSV Format',
        StartCheck: 'Start Check',
        StartExcel: 'Start Excel',

        resStatement: 'Reservation Statement',
        resOptions: 'Options',
        resCompareNetto: 'Compare amount with netto (price excluding services)',
        resComparePayment: 'Compare amount with payments (all registered payments)',
        payoutStatement: 'Payout Statement',
      },
      bookingsheet: {
        title: 'This function was moved to a different page',
        redirect: 'Please navigate to: Settings -> Booking sheets',
        action: 'There click on the Display Button (next to the desired booking sheet) to generate the booking sheet',
      },
      bfs:{
        month: 'Month',
        RoomForDisabled: 'Rooms for Disabled available (at least one)',
        ContactName: 'Contact name',
        ContactPhone: 'Contact phone',
        ContactEMail: 'Contact email',
        NextClosingFrom: 'Next closing dates : begin',
        NextClosingTo: 'Next closing dates : end',
        TotalOpenDays: 'Open days',
        check: 'Check',
        send: 'Send',
        report: 'Report',
        clear: 'Clear',
        dialog: {
          info: {
            Ident: 'BUR-Number',
            Period: 'Month',
            Automatic: 'Automatic',
            RoomForDisabled: 'Room for disabled',
            ContactName: 'Contact person',
            ContactPhone: 'Contact phone',
            ContactEMail: 'Contact e-mail',
            NextClosingFrom: 'next closing from',
            NextClosingTo: 'next closing to',
            TotalOpenDays: 'total open days',
          },
          numRoom: 'numRoom',
          numBed: 'numBed',
          TotalOccupiedRooms: 'TotalOccupiedRooms',
          AvgNightIncome: 'AvgNightIncome',
        },
        noBur: 'Please send the BUR-Number to alixon to use the semi-automatic delivery.',
      },
      documents: {
        download: 'download',
        show: 'show',
      },
      gdpr: {
        searchtitle: 'E-Mail or guest id',
        searchbutton: 'Search',
        clearmailtxtbutton: 'clear mail text',
        guestremarktitle: 'Guest remark',
        General: 'General',
        reservations: 'Reservations',
        resno: 'Res #',
        status: 'Status',
        arrival: 'Arrival',
        departure: 'Departure',
        remark: 'Remark',
        erasereference: 'Erase request reference',
        erasebutton: 'Erase all personal information',
        wronghostel: 'wrong hostel id',
      },
      guestexport: {
        datafields: 'Datafield selection',
        email: 'E-mail address',
        address: 'Full address',
        allfields: 'All fields',
        gastcats: 'Guest categories',
        allGuests: 'All guests',
        resfilter: 'additional reservation filter',
        allres: 'All reservations',
        arrival: 'Arrival',
        stay: 'Stay',
        departure: 'Departure',
        startdate: 'Start date',
        enddate: 'End date',
        agents: 'Additional agent filter',
        allAgents: 'All Agents',
        Export: 'Excel Export',
        dummy:''
      },
      history: {
        res: {
          gast: 'Guest',
          ankunft: 'Arrival',
          dauer: 'Nights',
          abreise: 'Departure',
          wichtig: 'Important',
          erinnerung: 'Reminder',
          netto: 'Net',
          bemerkung: 'Remark',
          anzPers: 'Num of persons',
          status: 'Status',
          agent: 'Agent',
          buchungskanal: 'Booking channel',
          bezahlt: 'Paid',
          totalservice: 'Services',
          total: 'Total',
          due: 'Due',
        },
        val: {
          res: {
            status: {
              0: 'Normal',
              1: 'Temporary',
              2: 'Fix',
              3: 'Checked-in',
              4: 'No-show',
              5: 'Cancelled',
              6: 'Checked-out',
            }
          },
        },
        beds: 'Beds',
        details: 'Details',
        created: 'Created',
        edited: 'Edited',
        deleted: 'Deleted',
        canceled: 'Canceled',
        hidden: 'Hidden',
        service: 'Service',
        zahlungen: 'Payments',
        element: 'Element',
        count: '# Reservations',
        reservations: 'Reservations',
        delete: 'Delete',
        deletetitle: 'Delete reservation #',
        deltext: 'Cancel message',
        cancel: 'Cancel reservation',
        defdelete: 'Delete reservation (permanent)',
        reactivate: 'Reactivate',
        reactivateTooltip: 'Reactivate reservation (set status to NoShow)',
        group: 'Group',
        rebuild: 'Rebuild log index',
        infolabel: 'Display changes since 2025-04-02',
        grpempty: 'No group reservations found',
      },
      stats: {
        title: 'Current data:',
        DBcon: 'Current DormBook sessions',
        res_nr: 'resevation number',
        resdatum: 'newest resevation',
        onlinedatum: 'newest online reservation',
        cnt: 'total teservations',
        gastinfo: 'total guests',
        dayinfo_min: 'first date',
        dayinfo_max: 'last date',
        roominfo: '# of rooms',
        bedinfo: '# of beds',
        firstbooking: 'first booking',
        lastbooking: 'last booking',
        addbed: 'Additional bed',
        deleted: 'Deleted',
        users: 'Users',
        none: 'none',
        showall: 'Show all users',
        abr: 'Statement of charges:',
      },
      guesthistory: {
        name: 'Name',
        vorname: 'First name',
        land: 'Country',
        passland: 'Nationality',
        email: 'Email',
        bemerkungen: 'Remark',
        station: 'Station',
        bem: 'Special',
        infolabel: 'Display changes since 2025-07-03',
      },
      report: {
        language: 'Language',
        reportType: 'Report type',
        startDate: 'Start date',
        endDate: 'End date',
        oneDayBack: '1 day back',
        today: 'today',
        addOneDay: 'add 1 day',
        oneMonthBack: '1 month back',
        thisMonth: 'this month',
        addOneMonth: 'add 1 month',
        oneYearBack: '1 year back',
        thisYear: 'this year',
        addOneYear: 'add 1 year',
      },
      automail: {
        recOpt: {
          0: 'Guest',
          1: 'Hostel (one e-mail for each reservation)',
          2: 'Hostel (E-Mail mit einer Liste der Reservationen)',
        },
        artOpt: {
          0: 'Arrival',
          1: 'Departure',
          2: 'Arrival +',
        },
        artOpt2: {
          0: 'per reservation',
          1: 'per reservation group',
          2: 'per e-mail address',
        },
        condition: 'Condition',
        all: 'All',
        alltxt: '(If "All" is selected, every further selection will be subtracted)',
        other: 'Other',
        agenten: 'Agent',
        bookingchannels: 'Bookingchannel',
        languages: 'Languages',
        country: 'Countries',
        preiskat: 'Roomcategory',
        resstati: 'Status',
        receiver: 'Receiver',
        zeithelper: 'hours before 24:00h of arrival date / after 00:00h of departure date',
        without: 'without ',
        test: 'Test results',
      },
      autorep: {
        none: '',
        choose: 'Please select',
        flex: 'flex',
        monatlich_last: 'monthly (last)',
        monatlich_last_p10: 'monthly (last) + 10 days',
        monatlich_cur: 'monthly (current)',
        monatlich_next: 'monthly (next)',
        monatlich_p12: 'monthly (+12 months)',
        woechentlich_MoSu: 'weekly (Mo-Su)',
        woechentlich_Hp12M: 'weekly (today/+12 months)',
        taeglich_YY: 'daily (yesterday/yesterday)',
        taeglich_YT: 'daily (yesterday/today)',
        taeglich_TT: 'daily (today/today)',
        taeglich_TM: 'daily (today/tomorrow)',
        taeglich_MM: 'daily (tomorrow/tomorrow)',
        taeglich_p30: 'daily (+1 month)',
        taeglich_1p12M: 'daily (1st/+12 months)',
        taeglich_Mp3d: 'daily (tomorrow/+3 days)',
        taeglich_Hp3d: 'daily (today/+3 days)',
        taeglich_Hp12M: 'daily (today/+12 months)',
      },
    },
    set: {
      acquirer: {
        title: 'Acquirer, Buchungsgebühren und Kreditkarten-Informationen',
        intro1: 'If a guest is booking via DormOnline, the credit card used will be charged with a possible booking fee in collaboration with ',
        intro2: ' and checked by this way.',
        intro3: 'In order to store credit card information according to the guidelines of ',
        intro4: ' that get more and more severe, this is saved exclusively with ',
        intro5: '. For this reason subsequent charges are processed directly by Stripe.',
        intro6: 'Without any action by the hostel possible “No-show” charges are transferred to alixon once a month and can then – according to the agreement with the responsible contact person – be set off against the current invoice or paid out.',
        intro7: 'We recommend all hostel owners and managers to check on the list of ',
        intro8: 'Stripe countries',
        intro9: 'whether you can open an own account for your property. The country of the head office is relevant. There are three alternatives:',

        introOpt1p1: ' If the country is ',
        introOpt1p2: 'not listed',
        introOpt1p3: ' on the list of Stripe countries, you cannot open an own Stripe account. However we recommend you to ',
        introOpt1p4: 'enroll',
        introOpt1p5: ', so that Stripe knows that somebody is interested in using Stripe also in your country.',

        introOpt2p1: ' If the country is listed as ',
        introOpt2p2: '"private Beta"',
        introOpt2p3: ', you ',
        introOpt2p4: 'enroll',
        introOpt2p5: ' best in your country and ask Stripe to send you an invitation. Not before the Stripe account is open you can connect it by the following link with the DormProject hostel %{hostel} ',
        introOpt2p6: 'Connect %{hostel}  to the existing Stripe account.',

        introOpt3p1: ' If the country is listed as ',
        introOpt3p2: 'Stripe country',
        introOpt3p3: ' or ',
        introOpt3p4: '“open Beta”',
        introOpt3p5: ', you can just open a Stripe account using the link below:',
        introOpt3p6: 'Open a Stripe account for %{hostel} and connect to DormProject.',

        introFinal: 'If this DormProject hostel has been successfully connected with the own Stripe account, you will see a corresponding confirmation on this page.',

        merchant1: 'It\'s imporatant, that the ',
        merchant2: ' of your Stripe-Account is set correctly. In most cases ',
        merchant3: ' is a good guess. Please contact ',
        merchant4: '  to check this setting.',

        conInfo1: 'This DormProject hostel has been successfully connected with its own ',
        conInfo2: ' account.',
        moreInfo: 'More information',
        stripeCountries: 'Stripe countries',
      },
      agecategory: {
        title: 'Age Categories',
        titleCreate: 'Create Age Category',
        titleEdit: 'Edit Age Category',
        description: 'Online description',
        help:'Singular/plural (e.g. Child/Children)',
        help2:'Categories with identical descriptions will be grouped together in the booking process and in confirmations.',
        showdel: 'Show deleted',
      },
      agent: {
        title: 'Agent',
        titleCreate: 'Create Agent',
        titleEdit: 'Edit Agent',
        id_agent: 'Agent',
        id: 'Id',
        firma: 'Organisation',
        plz_ort: 'Zip / City',
        code: 'Code',
        kontakt: 'Contact',
        strasse: 'Address',
        land: 'Country',
        tel: 'Phone',
        fax: 'Fax',
        email: 'Email',
        emailtype: 'Send confirmation e-mails to',
        bank: 'Bank name',
        postkonto: 'Post Account',
        bankclearing: 'Bank clearing',
        kontonummer: 'Account Number',
        mwst: "VAT No.",
        error: {
          deletefailed: 'There are contracts assigned to this agent. Delete refused.',
          maxlength: 'Maximum length cannot be greater than %{max}',
          regex: 'invalid Code: only numbers (0-9), letters(a-zA-Z) and \'_\' allowed',
        },
      },
      agentcontract: {
        title: 'Agent contracts',
        titleCreate: 'Create Agent contract',
        titleEdit: 'Edit Agent contract',
        id_agent: 'Agent',
        color: 'Color',
        kom_buchung: 'Commission booking',
        kom_buchung_help: '%, negative Values: Service Charge in Main Currency',
        kom_buchung_unit: 'Unit',
        id_zahlungsart_react: 'Down payment',
        bwo: 'BookWorldOnline',
        ohne_kk: 'Booking without credit card',
        aufpreis: 'Commission on top of price',
        bookingfee: 'CC Booking fee',
        kom_link: 'Commission link',
        kom_link_help: 'Only used for reports',
        bruttopreisbuchen: 'Book gross price',
        nettopreisbuchen: 'Book net price',
        bwoNo: 'No BWO',
        bwoNR: 'No Rates',
        bwoMR: 'Use Rates',
        pricePaymentSettings: 'Price / Payment settings',
        buchungAgentWebsite: 'Booked on agents website',
        bookingChannelInternet: '(Booking Channel: Internet)',
        buchungDurchAgent: 'Booked by Agent',
        bookingChannelAgent: '(Booking Channel: Agent) [param: book]',
        error: {
          deletefailed: 'An agent contract can not be deleted after setting up an automatic interface!',
          posReordered: 'position re-ordered!',
          kom_buchung: 'Commission booking must be smaller than 101',
          kom_buchung_min_kom: 'The price plan requires a minimum commission of %{value}',
          kom_buchung_fix: 'Commission booking must be %{value}',
          kom_buchung_unit: 'The unit must be on currency',
          kom_link: 'Commission link must be smaller than 100',
          onTopNull: 'Commission on top of price needs to be deactivated',
          setNoRates: "BookWorldOnline needs to be set to 'No Rates'",
          setZaBrutto: "Down payment needs to be set to 'Book gross price'",
          bookingfeeOn: "Buchungsgebühr KK needs to be aktivated",
          id_agent: "Please select an agent",
        },
      },
      bed: {
        title: 'Beds',
        titleCreate: 'add bed',
        titleEdit: 'edit bed',
        selectroom: 'Select room',
        errnodata: 'Bed could not be deleted as there are still bookings found',
      },
      bookingsheet: {
        title: 'Booking sheets',
        titleCreate: 'add booking sheet',
        titleEdit: 'edit booking sheet',
        helptitle: '[Title];[E-mail subject];[mark] (e.g.: CheckOut E-Mail;Thanks for staying with us;@)',
        helppdfconf: '[only available for Supporters]<br>'+
                     'border: all[mm] <br>'+
                     'border: topbottom[mm], rightleft[mm] <br>'+
                     'boder: top[mm], right[mm], bottom[mm], left[mm] <br>'+
                     'border-left: left[mm] <br>'+
                     'papersize: *A4* | Letter | width[mm], height[mm] <br>'+
                     'textfont: courier | *helvetica* | monospace | sans | serif | times <br>',
        pleaseselect: 'Please select',
        Testdialog: 'Test bookingsheet',
        Displaydialog: 'Display bookingsheet',
        resnr_help: 'Reservation no (Optional)',
        email_help: 'Email address',
        email_sent: 'Email has been sent',
        dormbook: 'DormBook',
        noAccess: 'not available',
        pdf: 'only pdf document',
        email: 'only e-mail',
        pdf_email: 'pdf document and e-mail',
        perResGroup: '1x pro reservation group',
        perRes: '1x per reservation',
        perGuest: '1x per guest',
        insert: '+ Insert',
        delete: '+ Delete',
        deleteconfirm: 'Do you really want to delete this element: ',
        yes: 'Yes',
        no: 'No',
        link: 'Link',
        image: 'Image',
        table: 'Table',
        tablebody: 'Table body',
        tablerow: 'Table row',
        tablehead: 'Table head',
        tablecell: 'Table cell',
        paragraph: 'Paragraph',
        div: 'Div',
        span: 'Span',
        quote: 'Quote',
        headingone: 'H1',
        headingtwo: 'H2',
        headingthree: 'H3',
        headingfour: 'H4',
        headingfive: 'H5',
        headingsix: 'H6',
        numberedlist: 'Numbered list',
        bulletedlist: 'Bulleted list',
        listitem: 'List item',
        hr: 'Line',
        br: 'Newline',
        var: 'Variable',
        font: 'Font',
        text: 'Text',
        docxfile: 'docx file',
        fixed1: 'The structure of the document was corrected automatically. Please check the layout again',
        fixed2: 'The structure of the document could not be corrected automatically. Please look for html fragments in your design',
        dismiss: 'Accept changes',
        copytitle: 'Copy bookingsheet',
        copyinfo: 'Please enter a name for the copy',
      },
      dbuser: {
        title: 'Users',
        titleCreate: 'Create User',
        titleEdit: 'Edit User',
        active: 'Active',
        activate: 'Aktivate / Set passwort',
        locked: 'Locked',
        unused: 'Unused',
        inactive: 'Inactive',
        loginname: 'Username',
        name: 'Name',
        email: 'Email',
        id_db_loginlevel: 'user group',
        id_fw_gruppe: 'user group admin',
        newpwd: 'Set new password',
        activatetitle: 'Activate User / Set new password',
        newPasswordInfo: 'New password for user ',
        yubico: 'Yubico',
        yubicohelper: 'If you don\'t have a yubico key, leave this field empty. Else simply trigger your yubico key in the field.',
        error: {
          invalidChars: 'Invalid characters in login name. Allowed: a-z, A-Z, 0-9!',
          reactivateUser: 'There is a deactivated user with this username - to reactivate click the linkk below!',
          doubleEntry: 'Duplicate entry: This loginname does already exist.',
          invalidEmail: 'Invalid email address',
        },
      },
      guestcategory: {
        title: 'Guest Categories',
        titleCreate: 'Create Guest Category',
        titleEdit: 'Edit Guest Category',
      },
      guestdetail: {
        title: 'Guest Fields',
        titleCreate: 'Guest Field erstellen',
        titleEdit: 'Guest Field bearbeiten',
        options: 'Select options',
        desc:'Description',
      },
      hostel: {
        titleEdit: 'Property Settings',
        property: 'Property',
        map: 'Map',
        invoice: 'Invoicing',
        login_name: 'Log-in name',
        hostel: 'Name',
        name: 'Contact person',
        cc_text: 'CC reference',
        strasse: 'Address',
        plz: 'ZIP',
        ort: 'City',
        land: 'Country',
        region: 'State/Prefecture',
        telefon: 'Phone',
        email: 'Email',
        res_email: 'Email 2',
        res_email_desc: 'This e-mail address is used for reservation confirmations (BWO and Interfaces)',
        url: 'Website',
        mapdesc:'Move the map to place the pin at your location.',
        max_dormbook: 'DormBook licences',
        interfacemin: 'min invoiced interfaces',
        preisplan: 'Price plan',
        id_reseller: 'Reseller',
        id_2supporter: '2nd Level Support',
        id_supporter: 'Supporter',
        id_kundeabrechreseller: 'Invoicing',
        id_kundeabrechnung: 'Customer number',
        setupfee: 'Setupfee charged',
        id_promotinghostel: 'Promotion reduction for hostel',
        rabatt: 'Reduction',
        rabattart: 'Reduction type',
        credituse: 'Use of credits',
        resellerremark: 'Remarks: from reseller (e.g. pricing, special deals)',
        cost:'Costs',
        monthly:'Monthly costs',
        balancerep:'Balance report',
        date:'Date',
        amount:'Amount',
        balance:'Balance',
        config:'Configuration',
        timeZone:'Time zone',
        timeZoneInfo:'Please select the time zone the hostel is in.',
        currency0:'Main currency',
        currency0Info:'Please use currency codes according to the ISO specification: http://en.wikipedia.org/wiki/ISO_4217',
        currency1:'Currency 1',
        currency1Info:"needs to be '&#8364; %01.2f' for the GOMIO-interface",
        currencyRate1:'Exchange rate 1',
        currency2:'Currency 2',
        currencyRate2:'Exchange rate 2',
        noSplitVat:'No Split VAT',
        splitVat:'Split VAT',
        splitVatInfo:'Split the amount for the stay into partial amounts with different VAT rates',
        noVat:'Without VAT',
        normalVat:'Publish prices with Vat',
        noVatPaid:'Assume tax of agent commission as paid',
        noVatAdd:'Tax of agent commission added to the due amount',
        noVatInfo:'Publish the prices in DormOnline and all the Interfaces without VAT',
        pluginOccHistory:'Plugin: Occupancy History',
        pluginOccHistoryInfo:'Regularly save the availabilities',
        pluginOccHistoryState_0:'not active',
        pluginOccHistoryState_1:'active',
      },
      payment: {
        title: {
          refund: 'Refund',
          charge: 'new Charge to this Card',
          addCust: 'Add stripe customer',
        },
        amount: 'Amount',
        addCust: 'Add stripe customer',
        addCustTxt: 'For this reservation is no card information stored!',
        addCustLbl: 'Customer token (cus_...)',
        card: 'Card',
        charge: 'Charge the card',
        custAdd: 'The customer was added',
        custExists: 'The customer already exists',
        dormproject: 'DormProject',
        interror: 'Internal Error (Refund)',
        max_text_error: 'maximum 13 characters',
        nonNumeric: 'has to be a number',
        notfound: 'The record could not be found',
        paymentsucessful: 'Payment sucessful submmitted. It could take a few minuntes, until the change is visible in DormProject',
        refund: 'Refund',
        resno: 'Reservation number',
        refundsucessful: 'Refund sucessful submmitted. It could take a few minuntes, until the change is visible in DormProject',
        text: 'Payment text',
      },
      paymenttype: {
        title: 'Payment types',
        titleCreate: 'Create Payment Type',
        titleEdit: 'Edit Payment Type',
        showdel: 'Show deleted',
      },
      payrequest: {
        title: 'Payment time ',
        prozent: '%',
        fix: 'fix',
        naechte: 'Nights',
        rest: 'remaining amount',
        buchung: '@ booking',
        nachbuchung: 'days after booking',
        vorankunft: 'days before arrival',
        checkin: '@ check-in',
      },
      prefcountry: {
        title: 'Main Countries',
        titleCreate: 'Add Country',
        titleEdit: 'Edit Country',
      },
      pricecomp: {
        title: 'Price comparison',
      },
      pwdyubi: {
        titleEdit: 'Change password',
        pwdtitle: 'Change password for: ',
        pwdinfo: 'This is to change the password for your account in admin.book.world, resp. secure.dormproject.ch.',
        pwdinfo2: 'The password for your user in the Book.World Desktop-App (DormBook) can be changed in the app.',
        passwort: 'New Password',
        passwort2: 'Password retype',
        pwdErr: 'Password and retype don\'t match.',
        yubititle: 'Yubico',
        yubiinfo: 'The yubico key %{yubi} is assigned to your user.',
        yubico: 'USB key for access control',
        yubicohelp: 'simply trigger your yubico key in the field.',
        yubicodel: 'clear yubico key',
      },
      rate: {
        title: 'Rates',
        titleEdit: 'Edit Payment Options',
        cancelpoints:'Cancelation restrictions',
        actionNo:'No Action',
        actionCancel:'Cancel reservation',
        id_payrequest: 'Payment points',
        id_storno: 'Cancelation restrictions',
        nobwo: 'Not active',
        bwoactive: 'active',
        bwochange: 'online change allowed for guests',
      },
      room: {
        title: 'Edit rooms',
        titleCreate: 'Add Room',
        titleEdit: 'Edit Room',
        editBeds: 'Edit beds',
        bedcount: 'Number of beds',
        errnodata: 'Room could not be deleted as there are still beds defined.',
        bezeichnungInfo: 'For each line in this field, a room will be created with the parameters below.',
        dokuLink: '<a href="https://docs.dormproject.ch/en/konfiguration---dormonline/zimmer/zimmer-online.html" target="_blank" rel="noopener noreferrer" >Documentation</a>',
      },
      roomcategory: {
        title: 'Room Category',
        titleCreate: 'Add Room Category',
        titleEdit: 'Edit Room Category',
        rooms: 'Assigned rooms',

        in_bfs: 'Stat',
        in_daily_list: 'Day',
        in_report: 'Rep',
        room_cnt: 'Rooms',

        dormbookSetting: 'DormBook Setting',
        dormonlineSetting: 'DormOnline Setting',
        reportSetting: 'Report Setting',
        units: 'Units',
        units_info: 'Dormitory and private rooms (dormitory singluar/plural/private singular/plural)',
        bwoSetting: 'BookWorldOnline Setting',
        roomSetting: 'Room Setting',
        
        errRoomNotEmpty: "Room category can't be deleted, since there are still rooms assigned. First reassign the rooms to new categories.",
      },
      roomcattext: {
        title: 'Texts for ',
        textBWO: 'BWO Roomcategory Texts',
      },
      service: {
        title: 'Additional services',
        titleCreate: 'Add additional services',
        titleEdit: 'Edit additional services',
        anz_modifier: 'Condition',
        anz_modifier_comment: "separate values by | or newline<br><b>options/example:</b><br>LimitNightsMax=7<br>MinNights=8<br>MaxNights=2<br>ConnectedRoomtypes={id},{id}<br>ConnectedAgecategories={id},{id}<br>ConnectedAgent={id},{id}<br>ChildService={id},{id}<br>UnsetService={id},{id}",
      },
      servicetext: {
        title: 'Texts for ',
        textBWO: 'BWO Additional services Texts',
      },
      specialday: {
        title: 'Special days',
        titleCreate: 'Add Day',
        titleEdit: 'Edit Day',
        searchDate:'Filter date',
        searchDesc:'Search for description',
        text: 'Online text',
        copytitle: 'Copy date information',
        copyinfo: 'The settings of the selected date are copied to all dates between (and including) first and last date.',
        overwrite: 'All current settings are overriden without confirmation.',
        errnodata: 'Date is not defined. Please set it at «Calendar».',
      },
      tkonfigspez: {
        configure: 'Configure',
        info: {
          splitVAT: 'partial amount with different VAT rate',
          noVAT: 'Publish all prices without VAT\n(all booking-channels: DormOnline + Interfaces)',
          PaymentNumbers: 'Immeadely add payment numbers, when a payment is registered.',
          'BWO-Google': 'BWH: Additional fields for Google',
          'BWO-ServicePerLanguage': 'BWH: Services for all, one or no langague',
          BookingFee: 'DormOnline-booking fee',
          FlexBooking: 'DormOnline with FlexBooking',
          German: 'DormOnline add German',
          French: 'DormOnline add French',
          DormOnline_LastMinute: 'DormOnline LastMinute function',
          DormOnline_ConfirmCheckbox: 'Checkbox for Step 3 of DormOnline',
          DormOnline_DefaultLanguage: 'DormOnline default Language',
          DormOnline_weekly: 'DormOnline: book whole weeks only',
          DormOnline_cvv: 'DormOnline: CVV of credit card\n(DEPRECIATED)',
          DormOnline_Callback: 'DormOnline: Push-URL fo reservation',
          Callback_All: 'Global Push-URL',
          occupationHistory: '', BookWorldOnline: '', 'BWO-2nd-child-agecat': '', 'BWO-MultiRoomKonfig': '', 'BWO-Rates': '', 'BWO-cvv': '', OBE_LastMinute: '', stripe_nozip: '', storePaymentInfo: '', Calendar_Scheduler: '', Jungfrau_Gaestekarte: '', Zentralschweiz_TourX: '', BernWelcome2026: '', EasyChecking: '', MailChimp: '', Mailscheduler_Countryfilter: '', Hostel_legal_name: '', 
        },
        help: {
          splitVAT: 'define different VAT rates for partial amount of the stay. e.g. Tourist-Tax 0%.',
          noVAT: 'No support for HI hostels\nexample:\nprice 117, Commission 10%, Tax 17%\nOptions:\t\t\t\t\x1b[1mNoVAT=1\x1b[0m\t\t\t\x1b[1mNoVAT=2\x1b[0m\n\t\t\t\t\t\tpaid Tax Agent\tfull Tax guest\nHW-Commission\t\t\t10.00\t\t\t10.00\nHW-Due\t\t\t\t\t90.00\t\t\t90.00\n\x1b[1mbook with Payment type:\x1b[0m\t\t\nPrice in DormBook\t\t117.00\t\t\t117.00\npayment in DormBook\t11.70\t\t\t10.00\nDue in DormBook\t\t105.30\t\t\t107.00\n\x1b[1mbook net price:\x1b[0m\t\t\nPrice in DormBook\t\t105.30\t\t\t107.00\nDue in DormBook\t\t105.30\t\t\t107.00',
          PaymentNumbers: 'Already registred payment of the current month are automatically numbered.',
          'BWO-Google': '- Google-Analytics-Code,\n- Google-Maps-Link,\n- Google-API-Key',
          'BWO-ServicePerLanguage': '',
          BookingFee: 'Services (sold by DormOnline) are not supported:\n---------------------------------------------------\n- %, on top, Brutto Preis Buchen (Zusatzleistungen)\n- %, on top, Zahlungsart Preis Buchen (Zusatzleistungen)\n- %, inclusive, Netto Preis Buchen (zusatzleistungen)\n--> please check Agents - Contracts!!',
          FlexBooking: 'NOT supported:\n==============\n- fix amount, on top, Book gross price\n- fix amount, on top, payment type\n- fix amount, inclusive, Book net price\n=================================================================\nGood to know:\n====================================\nServices:\n- Services are calculated per Sub-Reservation',
          German: 'see "French"',
          French: 'this fields should be available:\nonline:\n45 - Title\n46 - Step 1\n47 - Step 2\n52 - Step 3\n53 - Step 4\n51 - not avail\n54 - Booking deleted\n55 - error\nemail:\n48 - New booking\n49 - Booking changed\n50 - Booking deleted\nif flex is configured:\n70 - New booking (flex)\n72 - Booking changed (flex)',
          DormOnline_LastMinute: 'During the "LastMinute" period the DormOnline does not take the "keep free" values in account.',
          DormOnline_ConfirmCheckbox: 'The Checkbox has to be checked before the reservation request is sent to the Server.',
          DormOnline_DefaultLanguage: 'if no Language is selected by DormOnline, the default Language is displayed.',
          DormOnline_weekly: 'NOT tested! DormOnline allows only to book whole weeks.',
          DormOnline_cvv: 'DormOnline requires a cvv for credit cards.',
          DormOnline_Callback: 'Callback-URL\nhttp://villa.verein-web.ch/newsletter_auto.php?vorname=%Firstname%&name=%Lastname%&email=%EMail%&anm=64680364d6e3907209295f8fd861652e\nParameter:\nvorname  First name as shown in the newsletter tool\nname  Name as shown in the newletter tool\nemail  e-mail as shown in the newsletter tool\nanm  long-id of newsletter instance',
          Callback_All: 'is called whenever a Reservation is saved\nTimeout: 5s',
          occupationHistory: '', BookWorldOnline: '', 'BWO-2nd-child-agecat': '', 'BWO-MultiRoomKonfig': '', 'BWO-Rates': '', 'BWO-cvv': '', OBE_LastMinute: '', stripe_nozip: '', storePaymentInfo: '', Calendar_Scheduler: '', Jungfrau_Gaestekarte: '', Zentralschweiz_TourX: '', BernWelcome2026: '', EasyChecking: '', MailChimp: '', Mailscheduler_Countryfilter: '', Hostel_legal_name: '', 
        },
      },
    },
  },
  glob: {
    actualPicture: 'uploaded picture',
    confirm: 'Confirm',
    copy: 'Copy',
    imgremove: 'remove',
    close: 'Close',
    move: 'Move',
    activate: 'Activate',
    uploadPicture: 'upload picture',
    columns: 'Columns',
    save: 'save',
    day: {
      short: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
      },
    },
    deftypes:{
      one: '* 1',
      num_nights: '* # of nights',
      num_person: '* # of person',
      num_night_person: '* # of nights * # of person',
      net_price: '* net price (stay)',
      price_per_night: '* price per night (average)',
    },
    dormbook:{
      not_accessible: 'not available',
      only_pdf: 'only pdf document',
      only_email: 'only e-mail',
      email_and_pdf: 'pdf document and e-mail',
    },
    dormbookdata:{
      per_group: '1x per reservation group',
      per_reservation: '1x per reservation',
      per_guest: '1x per guest',
    },
    error:{
      wrongHostel: 'Wrong Hostel',
      idNotFound: 'Id not found',
      noAccess: 'No Access',
      dbError: 'Could not write to database',
      paramError: 'Parameter error',
    },
    gender:{
      label: 'Gender',
      woman: 'Woman',
      man: 'Man',
      mixed: 'Mixed',
      empty: 'Empty',
      private: 'Private',
    },
    language:{
      de: 'German',
      en: 'English',
      fr: 'French',
    },
    agentEmailType:{
      guest: '(0) Guest',
      guest_agent: '(1) Guest + Agent',
      agent: '(2) Agent',
    },
    onlinechoices:{
      not_online: 'Not online',
      cons_book_woman: 'Consider bookings, Women',
      cons_book_man: 'Consider bookings, Men',
      cons_book_woman_man: 'Consider bookings, Women and Men',
      cons_book_mixed: 'Consider bookings, Mixed',
      cons_book_woman_mixed: 'Consider bookings, Women and Mixed',
      cons_book_man_mixed: 'Consider bookings, Men and Mixed',
      cons_book_all: 'Consider bookings, All options',
      ign_book_woman: 'Ignore bookings, Women',
      ign_book_man: 'Ignore bookings, Men',
      ign_book_mixed: 'Ignore bookings, Mixed',
    },
    onlinetypes:{
      not_online: 'Not Online',
      checkbox: 'Checkbox',
      num_selectable: '# selectable',
      fix: 'Fix',
    },
    resstatus:{
      stat0: 'normal (0)',
      stat1: 'temporary (1)',
      stat2: 'fix (2)',
      stat3: 'checked in (3)',
      stat4: 'no show (4)',
      stat5: 'cancelled (5)',
      stat6: 'checked out (6)',
    },
    servermsg:{
      paybill: 'We have not yet registered your payment for the open invoice(s).',
      accountcancelledNotPaid: 'We have not yet registered your payment for the final invoice(s). This account will be canceled. Please run any necessary reports prior to the cancellation date. We will thereafter archive/delete your data in accordance with our internal policies.',
      accountcancelled: 'This account will be canceled. Please run any necessary reports prior to the cancellation date. We will thereafter archive/delete your data in accordance with our internal policies.',
    },
    pwdremark: '-> Please make sure to write down this password!',
    pwdremark2: 'Note: this password has to be changed on first login!',
    pwdcopied: 'The password was copied',
    setpwd: 'Set password',
  },
  resources: {
    bwhAgent: {
      fields: {
        q: 'Search',
      },
    },
    bwhDiscount: {
      name: 'discount code |||| discount codes',
      forcedCaseName: 'discount code |||| discount codes',
      fields: {
        rabatt: 'Discount',
        rabatt_typ: 'Discount type',
        status: 'State',
        ankunft_min: 'Arrival from',
        ankunft_max: 'Arrival until',
        personen_min: 'Min. persons',
        personen_max: 'Max. persons',
        dauer_min: 'Min. stay ',
        dauer_max: 'Max. stay',
        abgelaufen: 'Expired codes',
      },
    },
    bwhGuestfield: {
      fields: {
        q: 'Search',
        orig_text: 'Original text',
        disp_opts: 'Display options',
        checkin: 'Check-in',
        validate: 'Validation',
      }
    },
    bwhImage: {
      name: 'Image |||| Images',
      forcedCaseName: 'Image |||| Images',
      fields: {
        art_lbl: 'Image type',
        art_lbl_tr: 'Image type',
        text: 'Image',
        id_element: 'Position',
      },
    },
    bwhRoomcategory: {
      fields: {
        bezeichnung: 'Category',
        img: 'Image',
        id_element: 'Position',
        not_onbwh: 'Not Online',
      },
    },
    bwhService: {
      fields: {
        bezeichnung: 'Service',
        img: 'Image',
        not_onbwh: 'Not Online',
      },
    },
    bwhSettings: {
      fields: {
        bwh_status: 'Status',
        bwh_defaultsprache: 'Default language',
        bwh_sprachen: 'Available languages',
        bwh_ident: 'Domain prefix',
        bwh_domain: 'Domain',
      },
    },
    bwhText: {
      name: 'Text |||| Texts',
      forcedCaseName: 'Text |||| Texs',
      fields: {
        art_lbl: 'Text type',
        id_agent: 'Agent',
        id_element: 'Position',
      },
    },
    calPricegr: {
      name: 'price group |||| price groups',
      forcedCaseName: 'price group |||| price groups',
      fields: {
        q: 'Search',
        bezeichnung: 'Description',
        mwst: 'VAT',
        preiskat: 'Room category',
        alterskat: 'Age category',
        belegung: 'Occupancy',
        preis: 'Price (Person)',
        preisRoom: 'Price (Room)',
        pricezero: 'Price = 0',
      },
    },
    calOnline: {
      name: 'online group |||| online groups',
      forcedCaseName: 'online group |||| online groups',
      fields: {
        q: 'Search',
        bezeichnung: 'Description',
        farbe: 'Color',
        copyTitle: 'New name',
      },
    },
    calOportal: {
      fields: {
        firma: 'Portal',
        kontingent: 'Cont.',
        freihalten: 'keep free',
        id_preiskat: 'Room category',
        min_nachtA: 'Min',
        max_nachtA: 'Max',
        noarrivalwd: 'n.Arr.',
        nodeparturewd: 'n.Dep.',
        firstres: 'First',
        lastnewres: 'New',
        lastchange: 'LM Change',
        lastminstart: 'LM Start',
        lastminend: 'LM End',
        zimmer: 'Rooms',
      },
    },
    calService: {
      name: 'service |||| services',
      forcedCaseName: 'service |||| services',
      fields: {
        q: 'Search',
        bezeichnung: 'Description',
        farbe: 'Color',
        copyTitle: 'New name',
        zusatzleistung: 'Service',
        preis: 'Price',
        mwst: 'VAT',
        online_type: 'Online',
      },
    },
    globHostel: {
      fields: {
        q: 'Search',
        hostel_id: 'Hostel ID',
        hostel: 'Hostel',
        cc_text: 'CC refferer',
        name: 'Contact Name',
        strasse: 'Address',
        plz: 'ZIP',
        land: 'Country',
        region: 'State/Prefecture',
        latitude: 'Latitude',
        longitude: 'Longitude',
        telefon: 'Phone',
        fax: 'Fax',
        email: 'E-Mail',
        res_email: 'E-Mail 2',
        url: 'URL',
        titel: 'URL',
        text_de: 'Text German',
        text_en: 'Text English',
        text_fr: 'Text French',
        max_dormbook: 'DormBook licences',
        Preisplan: 'Price plan',
        interfacemin: 'min invoiced interfaces',
        id_reseller: 'Reseller',
        id_kundeabrechreseller: 'Invoicing',
        id_kundeabrechnung: 'Customer number',
        id_promotinghostel: 'Promotion reduction for hostel',
        rabatt: 'Reduction',
        rabattart: 'Reduction type',
        credituse: 'Use of credits',
        resellerremark: 'Remarks: from reseller (e.g. pricing, special deals)',
        guestdetail: 'copy guest details',
        alterskat: 'copy age categories',
        zahlungsart: 'copy payment types',
        zusatzleistung: 'copy services',
      },
    },
    repDocuments: {
      fields: {
        datum: 'Date',
        type: 'Type',
        flag: 'New',
        titel: 'Title',
        filename: 'Filename',
      },
    },
    repMessages: {
      fields: {
        betreff: 'Subject',
        id_hostel: 'Hostel',
        receiver: 'Receiver',
        type: 'Type',
        zeit: 'Date',
      },
    },
    repHistory: {
      fields: {
        res_no: 'Reservation number',
        action: 'Action',
        datum: 'Local time',
        hosteltime: 'Hostel time',
        portal_user: 'Portal user',
        info: 'Info',
      },
    },
    repGuesthistory: {
      fields: {
        guest_no: 'Guest number',
        action: 'Action',
        datum: 'Local time',
        hosteltime: 'Hostel time',
        portal_user: 'Portal',
        info: 'Info',
      },
    },
    repAutomail:{
      fields: {
        art: 'Report type',
        art2: 'Send emails',
        zeit: 'Time',
        id_buchungsblatt: 'Booking sheet',
      }
    },
    setAgecategory: {
      empty: 'No age category yet.',
      fields: {
        bezeichnung: 'Description',
        abk: 'Shortcut',
        id_parent: 'Parent category',
        preis_modifier: 'Price modifier',
      },
    },
    setAgent: {
      name: 'agent |||| agents',
      forcedCaseName: 'agent |||| agents',
      empty: 'No agent yet.',
      fields: {
        q: 'Search',
        id: 'Id',
        firma: 'Organisation',
        plz_ort: 'City',
        code: 'Code',
        kontakt: 'Contact',
        strasse: 'Street',
        land: 'Country',
        tel: 'Phone',
        fax: 'Fax',
        email: 'Email',
        emailtype: 'Email Type',
        bank: 'Bank',
        postkonto: 'Post Account',
        bankclearing: 'Bank clearing',
        kontonummer: 'Account No',
        mwst: "VAT",
      },
    },
    setAgentcontract: {
      name: 'agent contract |||| agent contracts',
      forcedCaseName: 'agent contract |||| agent contracts',
      empty: 'No contract yet.',
      fields: {
        q: 'Search',
        id: 'Id',
        pos: 'Pos',
        firma: 'Organisation',
        plz_ort: 'City',
        kom_buchung: 'Book',
        aufpreis: 'on Top',
        bookingfee: 'Fee',
        zart: 'Type',
        ohne_kk: 'no CC',
        kom_link: 'Link',
      },
    },
    setBed: {
      name: 'bed |||| beds',
      forcedCaseName: 'bed |||| beds',
      empty: 'No bed yet.',
      invite: 'create a first one?',
      fields: {
        id_zimmer: 'Room',
        buchstabe: 'Bed',
        matratze: 'Additional bed',
        bemerkung: 'Remark',
      },
    },
    setBookingsheet: {
      empty: 'No booking sheet yet.',
      invite: 'create a first one?',
      fields: {
        titel: 'Title',
        id_sprache: 'Language',
        pdfconf: 'PDF Conf',
        dormbook: 'DormBook',
        data: 'Daten',
        id_datei: 'docx file',
        html: 'HTML',
        text: 'Text',
        q: 'Search',
      },
    },
    setDbuser: {
      name: 'user |||| users',
      forcedCaseName: 'user |||| users',
      empty: 'No Users yet.',
      fields: {
        q: 'Search',
        loginname: 'user name',
        name: 'Name',
        email: 'Email',
        id_db_loginlevel: 'user group',
        id_fw_gruppe: 'user group admin',
        status: 'Status',
        yubi: 'Yubico',
        hid: 'HID',
        inactive: '(inactive)',
        last_change: '(change)',
        edit_en: '',
      },
    },
    setDbuserglob: {
      name: 'user |||| users',
      forcedCaseName: 'user |||| users',
      empty: 'No Users yet.',
      fields: {
        q: 'Search',
        loginname: 'user name',
        name: 'Name',
        email: 'Email',
        id_db_loginlevel: 'user group',
        id_fw_gruppe: 'user group admin',
        status: 'Status',
        yubi: 'Yubico',
        hid: 'HID',
        inactive: '(inactive)',
        last_change: '(change)',
        edit_en: '',
      },
    },
    setGuestcategory: {
      name: 'guest category |||| guest categorys',
      forcedCaseName: 'guest category |||| guest categorys',
      empty: 'No guest category yet.',
      invite: 'create a first one?',
      fields: {
        bezeichnung: 'Description',
      },
    },
    setGuestdetail: {
      empty: 'No guest fields yet.',
      invite: 'create a first one?',
      fields: {
        title_de: 'Title German',
        title_en: 'Title English',
        bez1_de: 'Field 1 German',
        bez1_en: 'Field 1 English',
        bez2_de: 'Field 2 German',
        bez2_en: 'Field 2 English',
        bez3_de: 'Field 3 German',
        bez3_en: 'Field 3 English',
        bez4_de: 'Field 4 German',
        bez4_en: 'Field 4 English',
        bez5_de: 'Field 5 German',
        bez5_en: 'Field 5 English',
        bez6_de: 'Field 6 German',
        bez6_en: 'Field 6 English',
      },
    },
    setHostel: {
      fields: {
      },
    },
    setPayment: {
      fields: {
        dat: 'Date',
        xml: 'Info',
        costs: 'Cost',
        bookingfee: 'BF',
        comission: 'Com',
        admin3: 'Admin3',
        connected: 'Con',
        amount: 'Amount',
        id_zahlungsart: 'Payment method',
        text: 'Payment text',
        add_res: 'Add to reservation payments',
      },
    },
    setPaymentapp: {
      fields: {
        res_nr: 'Res #',
        id_zahlungsart: 'Payment method',
        comment: 'Comment (Res)',
      },
    },
    setPaymenttype: {
      empty: 'No payment type yet.',
      invite: 'create a first one?',
      fields: {
        bezeichnung: 'Description',
      },
    },
    setPayrequest: {
      name: 'payment point |||| payment points',
      forcedCaseName : 'payment point |||| payment points',
      empty: 'No payment point yet.',
      invite: 'create a first one?',
      fields: {
        zeit: 'Time',
        zeitart: 'Time anchor',
        betrag: 'Value',
        betragart: 'Unit',
        active: 'active',
      },
    },
    setPrefcountry: {
      name: 'main country |||| main countries',
      forcedCaseName: 'main country |||| main countries',
      empty: 'No main country yet.',
      invite: 'create a first one?',
      fields: {
        id_land: 'Country',
      },
    },
    setRate: {
      name: 'rate |||| rates',
      forcedCaseName : 'rate |||| rates',
      empty: 'No rates yet.',
      invite: 'create a first one?',
      fields: {
        bezeichnung: 'Description',
        id: 'Payment points',
        erinnerung: 'Reminder',
        frist: 'Deadline',
        aktion: 'Action',
        id_payrequest: 'Payment points',
        id_storno: 'Cancelation restrictions',
        min_stay: 'Min nights',
        max_stay: 'Max nights',
        min_pers: 'Min pers.',
        max_pers: 'Max pers.',
        bwo_rate: 'BookWorldOnline',
        default_rate: 'Default option',
      },
    },
    setRoom: {
      name: 'room |||| rooms',
      forcedCaseName: 'room |||| rooms',
      empty: 'No rooms yet.',
      invite: 'create a first one?',
      fields: {
        bezeichnung: 'Description',
        id_preiskat: 'Room category',
        geschlecht: 'Gender',
        bett: 'Bed',
        zusatz: 'Additional bed',
        online: 'Online',
        pos: 'Pos',
        farbe: 'Color',
        id: 'ID',
      },
    },
    setRoomcategory: {
      name: 'room category |||| room categories',
      forcedCaseName: 'room category |||| room categories',
      empty: 'No room category yet.',
      invite: 'create a first one?',
      fields: {
        q: 'Search',
        bezeichnung: 'Description',
        kurzbez: 'Shortcut (4 Characters)',
        farbe: 'Color',
        text_de: 'Text German',
        text_en: 'Text English',
        text_fr: 'Text French',
        bild: 'Picture',
        stattagrep: 'S/T/R',
        in_bfs: 'In statistics',
        in_daily_list: 'In daily lists',
        in_report: 'In reports',
        id: 'ID',
      },
    },
    setService: {
      name: 'service |||| services',
      forcedCaseName: 'service |||| services',
      empty: 'No services yet.',
      invite: 'create a first one?',
      fields: {
        bezeichnung: 'Description',
        bild: 'Picture',
        kuerzel: 'Shorcut',
        def_anz: 'Default number',
        def_type: 'Default type',
        online_type: 'Online',
        text_de: 'Text German',
        text_en: 'Text English',
        text_fr: 'Text French',
        pos: 'Pos',
        anz_modifier: 'Condition',
      },
    },
    setSpecialday: {
      empty: 'No spezial days yet.',
      invite: 'create a first one?',
      fields: {
        datum: 'Date',
        bemerkung: 'Description',
      },
    },
    setTkonfig: {
      fields: {
        q: 'Search',
      },
    },
  },
}
export default langEN;
